module.exports = __webpack_public_path__ + "static/img/arthroscopy-14.6c60d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-14.jpg
// module id = lwDi
// module chunks = 51